<template>
    <nav class="header navbar navbar-expand-lg navbar-dark"
        style="background: rgb(25, 118, 210); box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px; padding: 15px;">
        <div class="container">
            <span class="navbar-brand" style="font-weight: bold; color: rgb(255, 255, 255); font-size: 1.5rem;">
                <router-link to="/sleephealthscreen" style="color: rgb(255, 255, 255); text-decoration: none;">
                    <span>Welcome to
                        the</span> <span>Sleep Health
                        Screen Project</span>
                </router-link>
            </span>

            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
                aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="navbar-collapse collapse" id="navbarNav">
                <div class="me-auto navbar-nav">
                    <a role="button" class="nav-link" tabindex="0" href="#">
                        <router-link to="/sleephealthscreen">
                            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 576 512"
                                height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z">
                                </path>
                            </svg> Home
                        </router-link>
                    </a>
                    <a role="button" class="nav-link" tabindex="0" href="#">
                        <router-link to="/sleephealthscreen/about">
                            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512"
                                height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z">
                                </path>
                            </svg> About
                        </router-link>
                    </a>
                    <a role="button" class="nav-link" tabindex="0" href="#">
                        <router-link to="/sleephealthscreen/description-initiative">
                            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 352 512"
                                height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M96.06 454.35c.01 6.29 1.87 12.45 5.36 17.69l17.09 25.69a31.99 31.99 0 0 0 26.64 14.28h61.71a31.99 31.99 0 0 0 26.64-14.28l17.09-25.69a31.989 31.989 0 0 0 5.36-17.69l.04-38.35H96.01l.05 38.35zM0 176c0 44.37 16.45 84.85 43.56 115.78 16.52 18.85 42.36 58.23 52.21 91.45.04.26.07.52.11.78h160.24c.04-.26.07-.51.11-.78 9.85-33.22 35.69-72.6 52.21-91.45C335.55 260.85 352 220.37 352 176 352 78.61 272.91-.3 175.45 0 73.44.31 0 82.97 0 176zm176-80c-44.11 0-80 35.89-80 80 0 8.84-7.16 16-16 16s-16-7.16-16-16c0-61.76 50.24-112 112-112 8.84 0 16 7.16 16 16s-7.16 16-16 16z">
                                </path>
                            </svg> Description of the Initiative
                        </router-link>
                    </a>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
export default {
    name: "HeaderComponent"
};
</script>

<style scoped>
@media screen and (max-width: 767px) {
    .navbar-brand a {
        font-size: 0.8rem !important;
    }
}
</style>